import React from "react";

const ReportsPage = () => {return (<div></div>)}

export default ReportsPage